import request from "@/utils/request";

export function selectById(id) {
  return request({
    url: `/company/manage/selectById?id=${id}`,
    method: "get",
  });
}
export function updateById(data) {
    return request({
      url: "/company/manage/updateById",
      method: "post",
      data,
    });
  }